import { Icon, fas } from '..';

interface BooleanIconProps {
    value: boolean;
}

export const BooleanIcon = ({ value }: BooleanIconProps) => {
    if (value) {
        return <Icon icon={fas.faCheck} className="text-success" />;
    }
    return <Icon icon={fas.faTimes} className="text-danger" />;
};
